module.exports = __webpack_public_path__ + "static/media/filter_center_focus.f54ecaf2.svg";